<template>
  <div class="quote-list">
    <h3>报价管理</h3>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="quotationId" label="报价单编号"></el-table-column>
      <el-table-column prop="jobTitle" label="职位名称">
        <template slot-scope="scope"
          ><a
            :href="`${frontUrl}/job/detail/${scope.row.jobId}`"
            target="_blank"
            >{{ scope.row.jobTitle }}</a
          ></template
        >
      </el-table-column>
      <el-table-column prop="partyAName" label="甲方名称"></el-table-column>
      <el-table-column prop="partyBName" label="乙方名称">
        <template slot-scope="scope"
          ><a
            :href="`${frontUrl}/resume/detail/${scope.row.partyB}`"
            target="_blank"
            >{{ scope.row.partyBName }}</a
          ></template
        >
      </el-table-column>
      <el-table-column prop="partyBPhone" label="乙方手机号" />
      <el-table-column prop="fee" label="乙方手续费">
        <template slot-scope="scope">{{ scope.row.fee }} %</template>
      </el-table-column>
      <el-table-column prop="" label="报价单状态">
        <template slot-scope="scope">{{
          map.job.quoteStatus[scope.row.status]
        }}</template>
      </el-table-column>
      <el-table-column prop="" label="报价金额">
        <template slot-scope="scope">
          <template v-if="scope.row.chargingWay === 0">{{
            scope.row.monthlyRate
          }}</template>
          <template v-else>{{ scope.row.projectPrice }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="isRead" label="查看状态">
        <template slot-scope="scope">{{
          scope.row.isRead ? "已查看" : "未查看"
        }}</template>
      </el-table-column>
      <el-table-column prop="intention" label="筛选状态">
        <template slot-scope="scope">{{
          map.job.quoteIntention[scope.row.intention]
        }}</template>
      </el-table-column>
      <el-table-column prop="supportTrial" label="是否支持试用">
        <template slot-scope="scope">{{
          scope.row.supportTrial ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column prop="imNum" label="沟通数">
        <template slot-scope="scope">
          <!-- <a :href="`/msgs?sessionId=${scope.row.conversationId}`" target="_blank">{{scope.row.imNum}}</a> -->
          <span class="btn-text" @click="handleMsgs(scope.row)">
            {{ scope.row.imNum }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="投递时间"></el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";

const { job } = api;

export default {
  name: "quote-list",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
    };
  },
  components: {},
  computed: {
    jobId() {
      return this.$route.query.jid || "";
    },
    intention() {
      return this.$route.query.intention || "";
    },
    userId() {
      return this.$route.query.userBId;
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  created() {
    this.fetch();
  },
  mounted() {},
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        jobId: this.jobId,
        userBId: this.userId,
        intention: this.intention,
      };

      let res = await job.quotes(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    handleMsgs(row) {
      this.$router.push({
        path: "/msgs",
        query: {
          sessionId: row.conversationId,
          partyA: "",
          partyB: "",
        },
      });
    },
  },
};
</script>
<style scoped>
.btn-text {
  color: #1ab394;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/job/quotes.vue